import {useEffect} from 'react'

export const useConditionalEffect = (effect: () => void, condition = true) => {
  useEffect(() => {
    if (condition) effect()
  }, [condition])
}
